import React, { useEffect, useState, useContext } from 'react';
import { ProductModalContext } from '../../ProductModalContext';

import { Button } from 'web-store-modules/packages/web-store-ui-library'

import { AddToBagClicked, AddToWishlistClicked } from '../../../../../../utils/Analytics';
import { AddToCartContext } from '../../../../add-to-cart/AddToCartContext';
import { withTranslation } from 'react-i18next';
import I18NextContext from '../../../../../ui/i18next-context/I18NextContext'
import { getLocaleForAPI } from '../../../../../../../i18n/locales/utils';

const bagIcon = 'https://cdn.obsess-vr.com/ferragamo/Bag.svg';

const ProductModalButtonsNew = ({ sku, title, price, downsizedThumbnail, buttonFontStyle,
    addToCartFontStyle, buyNowFontStyle, productButtonCopy,
    addToCartCopy, url, cartUrl, setShowingAddToCartPrompt,
    addToCartEnabled, sizeDropdownEnabled, groupProducts, t,onClose }) => {

    const { variantSize, variantColor, productVariantMap, currQty, variantWidth,setRelatedProducts } = useContext(ProductModalContext)
    const { addToCart, removeFromCart, cartList, pricePrefix } = useContext(AddToCartContext);
    const [isInCart, setIsInCart] = useState(false);
    const [firstSeenInCartButton, setFirstSeenInCartButton] = useState(false);
    const { currentLanguage } = useContext(I18NextContext);
    const [addedToBag, setAddedToBag] = useState(false);

    // useEffect(() => {
    //     if (cartList.find(item => item.TITLE === title)) {
    //         setIsInCart(true);
    //     } else {
    //         setIsInCart(false);
    //     }
    // }, [cartList])

    const addToCartClicked = (option) => {
        // addToCart is only active when variantSize and variantColor are set
        if (sizeDropdownEnabled && !variantSize && !variantColor) {
            return;
        }
        const variantSKU = Object.keys(productVariantMap.features_map).length > 0 ? productVariantMap.features_map[variantColor][variantSize][variantWidth] : '';
        const productSKU = variantSKU ? variantSKU : sku;

        //const variantName = productVariantMap.siblings && productVariantMap.siblings[productSKU].name;

        const productName = title;
        console.log('added');
        addToCart({
            SKU: productSKU,
            TITLE: productName,
            PRICE: price,
            PRICE_PREFIX: pricePrefix,
            DOWNSIZED_THUMBNAIL: downsizedThumbnail,
            QTY: currQty,
            SIZE: variantSize,
            COLOR:variantColor,
            WIDTH: variantWidth,
            URL: productVariantMap.url.path
        });

        setAddedToBag(true);
        setTimeout(() => {
            setAddedToBag(false)
        }, 2000)

        AddToBagClicked(productSKU, productName);
        setFirstSeenInCartButton(true);

        setTimeout(() => {
            setRelatedProducts([]);
            onClose()
        }, 1000);
    }

    return (
        <>
            <Button
                className="product-button add-to-cart flex-center obsessvr-regularFont full-width pointer"
                style={{padding: '0 0.5em', marginRight: '0.1em'}}
                onClick={addToCartClicked}
            >
                <span><img style={{ marginRight: '6px'}} src={bagIcon} />{addedToBag? t('addedToCart'): t('addToCart') }</span>
            </Button>
        </>
    )
}

export default withTranslation()(ProductModalButtonsNew);